import * as React from 'react';
import type { SVGProps } from 'react';
const SvgJpgToPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#F4AC3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22.213 24h.9c.864 0 1.296 0 1.535-.18a.89.89 0 0 0 .351-.656c.018-.298-.222-.657-.701-1.375l-2.68-4.014c-.396-.593-.594-.89-.844-.994a.9.9 0 0 0-.682 0c-.25.104-.448.4-.844.994l-.663.992M22.214 24l-6.84-9.866c-.393-.568-.59-.852-.836-.951a.9.9 0 0 0-.67 0c-.246.1-.443.383-.836.95l-5.293 7.635c-.501.723-.752 1.085-.737 1.385.012.262.14.505.348.664.24.183.68.183 1.56.183zm1.78-13.333a2.67 2.67 0 0 1-2.67 2.666 2.67 2.67 0 0 1-2.67-2.666A2.67 2.67 0 0 1 21.323 8a2.67 2.67 0 0 1 2.67 2.667"
    />
  </svg>
);
export default SvgJpgToPdf;
